import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos - datos considerados "frescos"
      gcTime: 10 * 60 * 1000, // 10 minutos - tiempo en caché después de no usarse
      retry: (failureCount, error: any) => {
        // No reintentar en errores de autenticación
        if (error?.status === 401 || error?.status === 403) return false;
        return failureCount < 3;
      },
      refetchOnWindowFocus: false, // No refetch al cambiar de pestaña
    },
    mutations: {
      retry: false, // Las mutations no se reintentan automáticamente
    },
  },
});

// Crear persister para localStorage
const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'REACT_QUERY_OFFLINE_CACHE',
});

// Persistir solo la query de sesión
persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: 1000 * 60 * 60 * 24, // 24 horas
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      // Solo persistir la query de sesión
      return query.queryKey[0] === 'session';
    },
  },
});